// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1":"3fc706dd","74":"356cd140","141":"96c4a638","389":"bd2b87d3","593":"409eecf4","894":"70298a06"}[chunkId] + ".css";
};